import { render } from "./SettingsItem.vue?vue&type=template&id=02b99096&scoped=true"
import script from "./SettingsItem.vue?vue&type=script&lang=js"
export * from "./SettingsItem.vue?vue&type=script&lang=js"

import "./SettingsItem.vue?vue&type=style&index=0&id=02b99096&scoped=true&lang=scss"

import exportComponent from "/home/iskra/Projects/verum/admin-panel/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-02b99096"]])

export default __exports__